module.exports = {
      id: "default-card-image-usage",
      viewBox: "0 0 1024 683",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#default-card-image",
      toString: function () {
        return this.url;
      }
    }